export default "__VITE_ASSET__BIcZlCwU__"